import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

export default class extends Controller {
  static targets = ["main", "options"]

  connect() {
    useClickOutside(this)
  }

  toggle() {
    this.optionsTarget.classList.toggle("hidden")
  }

  open() {
    this.optionsTarget.classList.remove("hidden")
  }

  close() {
    this.optionsTarget.classList.add("hidden")
  }

  select({ params: { value } }) {
    if (this.hasMainTarget) this.mainTarget.textContent = value
  }

  clickOutside() {
    this.close()
  }
}
